export default "__VITE_ASSET__DnuI1FIf__"